<script setup lang="ts">
definePageMeta({
  name: 'inspections-category',
  layout: 'default',
  hideDefaultTopNav: true,
})

const currentPage = 1
</script>

<template>
  <HeaderWikiBitPcTopNav :always-expand-search="true" :force-solid-background="true" />
  <SurveyInspectionListContent :current-page="currentPage" />
</template>
